<template>
  <div class="mine-grid-box">
    <div class="item">
      <a @click="$router.push({ name: 'recharge'});"
        ><span class="icon-item icon1"></span>
        <p>存款</p></a
      >
    </div>
    <div class="item">
      <a @click="$router.push({ name: 'turnover',query:{type:1} });"
        ><span class="icon-item icon2"></span>
        <p>交易</p></a
      >
    </div>
    <div class="item">
      <a @click="$router.push({ name: 'turnover',query:{type:5} });"
        ><span class="icon-item icon3"></span>
        <p>投注</p></a
      >
    </div>
    <div class="item">
      <a @click="$router.push({ name: 'turnover',query:{type:6} });"
        ><span class="icon-item icon4"></span>
        <p>返水</p></a
      >
    </div>
    <div class="item">
      <a @click="$router.push({ name: 'withdraw'});"
        ><span class="icon-item icon5"></span>
        <p>取款</p></a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'MineGridView'
}
</script>
<style lang="scss" scoped>
.mine-grid-box {
  padding: 10px 20px;
  background-color: #222;
  color: #fff;
  border-radius: 0 0 4px 4px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  .item {
    display: inline-block;
    vertical-align: top;
    text-align: center;
    position: relative;
    .icon-item {
      width: 40px;
      height: 40px;
      display: block;
      margin-bottom: 5px;
    }
    .icon1 {
      background: url('../../../assets/images/mine/icon1.png') no-repeat;
      background-size: 100% 100%;
    }
    .icon2 {
      background: url('../../../assets/images/mine/icon2.png') no-repeat;
      background-size: 100% 100%;
    }
    .icon3 {
      background: url('../../../assets/images/mine/icon3.png') no-repeat;
      background-size: 100% 100%;
    }
    .icon4 {
      background: url('../../../assets/images/mine/icon4.png') no-repeat;
      background-size: 100% 100%;
    }
    .icon5 {
      background: url('../../../assets/images/mine/icon5.png') no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>
